export const getDefaultInputStyle = (fontClass: string) =>
  `w-full text-[16px] caret-action03 text-text-main-primary bg-transparent !outline-none border-none shadow-none p-0 w-full ${fontClass}`;
export const FILLED_INPUT_CLASS = 'filled';
